import { render, staticRenderFns } from "./TextDisplayModal.vue?vue&type=template&id=119b62d0&scoped=true"
import script from "./TextDisplayModal.vue?vue&type=script&lang=js"
export * from "./TextDisplayModal.vue?vue&type=script&lang=js"
import style0 from "./TextDisplayModal.vue?vue&type=style&index=0&id=119b62d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119b62d0",
  null
  
)

export default component.exports